import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '10 4.0799'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M18 1.60986C18 1.60986 15.17 3.00989 10 3.00989C4.83 3.00989 2 1.60986 2 1.60986C4.94 5.76986 8.12 6.54987 10 6.54987C11.88 6.54987 15.07 5.76986 18 1.60986Z"
          fill="white"
          stroke={outline}
          strokeMiterlimit="10"
        />
      </g>
    </g>
  )
}
